import * as React from 'react'
import * as VTree from 'react-vtree'
import { Container, CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import * as Api from './Api'
import * as Model from './Model'
import { useDrag } from 'react-dnd'
import { ItemTypes } from './Utils/types'
import { Group } from './Model'
import Box from './Box'
import Dustbin from './Dustbin'

export default function Classifier() {
  const { data: classifier, isLoading, error } = Api.useApi(
    '/classifier/1',
    Model.Classifier
  )

  if (isLoading && classifier === null) {
    return <CircularProgress />
  }

  return (

    <div>
      <div style={{ overflow: 'hidden', clear: 'both' }}>
        <Dustbin />
      </div>
      <div style={{ overflow: 'hidden', clear: 'both' }}>
        <Box  id={'1'} name="Яблоко" />
        <Box id={'2'} name="Груша" />
        <Box id={'3'} name="Банан" />
      </div>
    </div>
  )
}

interface NodeProps {
  onMouseOver: (id: string) => void
  onMouseOut: (id: string) => void
  onClick: (id: number, toggle: any) => any
  node: (id: number) => any
}

interface CustomNodeData {
  readonly isLeaf: boolean
  readonly name: string
  readonly nestingLevel: number
  readonly children: Group[] | []
}

const Node: React.FC<any> = ({
  data: { id, isLeaf, name, nestingLevel, parentId, children },
  isOpen,
  style,
  toggle,
  onMouseOver,
  onMouseOut,
  onClick,
}: NodeProps & VTree.FixedSizeNodeComponentProps<CustomNodeData>) => {
  const [{ isDragging }, drag] = useDrag({
    item: {  type: ItemTypes.NODE, name },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  console.log(isDragging)
  if (isDragging) {
    console.log(isDragging)
    return <div ref={drag} />
  }
  return (
    <div
      id={id}
      style={{
        ...style,
        marginLeft: nestingLevel * 30,
      }}
    >
      {!isLeaf && (
        <span>
          <button type="button" onClick={toggle}>
            {isOpen ? '-' : '+'}
          </button>
        </span>
      )}
      <span
        id={name}
        style={{
          opacity: isDragging ? '0.4' : '1',
          cursor: 'pointer',
        }}
        ref={drag}
        onMouseOver={() => onMouseOver(id)}
        onMouseOut={() => onMouseOut(id)}
        onClick={() => onClick(id, toggle)}
      >
        {name}
      </span>
    </div>
  )
}
const treeWalker = (classifier: Model.Classifier) =>
  function* (
    refresh: boolean
  ): Generator<
    VTree.FixedSizeNodeMetadata<CustomNodeData> | string | symbol,
    void,
    boolean
  > {
    const stack = classifier.children.map((group) => ({
      nestingLevel: 0,
      node: group,
    }))

    while (stack.length !== 0) {
      const { node, nestingLevel } = stack.pop()!
      const isOpened = yield refresh
        ? {
            id: node.id.toString(),
            isLeaf: (node?.children || []).length === 0,
            isOpenByDefault: false,
            name: node.name,
            children: node.children,
            nestingLevel,
          }
        : node.id.toString()

      if (node.children.length !== 0 && isOpened) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({
            nestingLevel: nestingLevel + 1,
            node: node.children[i],
          })
        }
      }
    }
  }
